export default __webpack_public_path__ + "static/media/winnerSchool.fdf2ad5e.svg";